module.exports = __webpack_public_path__ + "static/media/rok00.016fc722.png";